"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var core_user_service_1 = require("app/main/content/_service/core-user.service");
var tenant_1 = require("app/main/content/_model/tenant");
var user_1 = require("app/main/content/_model/user");
var material_1 = require("@angular/material");
var dialog_factory_component_1 = require("app/main/content/_components/_shared/dialogs/_dialog-factory/dialog-factory.component");
var util_1 = require("util");
var login_service_1 = require("app/main/content/_service/login.service");
var TenantHelpseekersFormComponent = /** @class */ (function () {
    function TenantHelpseekersFormComponent(coreUserService, dialogFactory, loginService) {
        this.coreUserService = coreUserService;
        this.dialogFactory = dialogFactory;
        this.loginService = loginService;
        this.dataSource = new material_1.MatTableDataSource();
        this.displayedColumns = ['firstname', 'lastname', 'username', 'actions'];
    }
    TenantHelpseekersFormComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.loaded = false;
                        this.dataSource.data = [];
                        _b = (_a = Promise).all;
                        _c = this;
                        return [4 /*yield*/, this.loginService.getGlobalInfo().toPromise()];
                    case 1:
                        _d = [
                            _c.globalInfo = (_f.sent())
                        ];
                        _e = this;
                        return [4 /*yield*/, this.coreUserService.findAllByRoleAndTenantId(this.tenant.id, user_1.UserRole.HELP_SEEKER).toPromise()];
                    case 2: return [4 /*yield*/, _b.apply(_a, [_d.concat([
                                _e.helpseekers = (_f.sent())
                            ])])];
                    case 3:
                        _f.sent();
                        this.dataSource.data = this.helpseekers;
                        this.loaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    TenantHelpseekersFormComponent.prototype.addHelpseeker = function () {
        var _this = this;
        this.dialogFactory.openAddHelpseekerDialog(this.helpseekers).then(function (ret) {
            var _a;
            if (!util_1.isNullOrUndefined(ret)) {
                (_a = _this.helpseekers).push.apply(_a, __spread(ret.helpseekers));
                _this.dataSource.data = _this.helpseekers;
            }
        }).catch(function (response) {
            console.error(response);
        });
    };
    TenantHelpseekersFormComponent.prototype.removeHelpseeker = function (helpseeker) {
        var _this = this;
        this.coreUserService.unsubscribeOtherUserFromTenant(this.tenant.id, user_1.UserRole.HELP_SEEKER, helpseeker.id).toPromise().then(function () {
            _this.helpseekers = _this.helpseekers.filter(function (h) { return h.id !== helpseeker.id; });
            _this.dataSource.data = _this.helpseekers;
        }).catch(function (response) {
            console.error(response);
        });
    };
    return TenantHelpseekersFormComponent;
}());
exports.TenantHelpseekersFormComponent = TenantHelpseekersFormComponent;
